<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <main>
        <section class="pt-10 pb-8 overflow-hidden">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <!-- Layout with Image on Left and Content on Right -->
            <div class="flex flex-col gap-8 lg:flex-row lg:gap-12">
              <!-- Fixed Image Section on Left -->
              <div class="flex-shrink-0 w-full lg:w-[400px]">
                <div class="sticky top-4">
                  <img :src="`/storage/images/BGUNG.png`" alt="Gedung Universitas Negeri Gorontalo"
                    class="object-cover w-full h-auto rounded-lg shadow-lg" />
                </div>
              </div>

              <!-- Scrollable Content Section on Right -->
              <div class="flex-1 w-full">
                <div
                  class="overflow-y-auto max-h-[600px] px-4 py-6 bg-white rounded-lg shadow-sm border border-gray-100 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                  <div class="space-y-8">



                    <div>
                      <span
                        class="block pb-2 mb-4 text-xl font-bold text-gray-800 border-b border-gray-200">Visi:</span>
                      <div class="leading-relaxed prose text-gray-700 prose-gray max-w-none"
                        v-html="profil.data[0].visi"></div>
                    </div>
                    <div>
                      <span
                        class="block pb-2 mb-4 text-xl font-bold text-gray-800 border-b border-gray-200">Akreditasi:</span>
                      <div class="leading-relaxed prose text-gray-700 prose-gray max-w-none"
                        v-html="profil.data[0].akreditasi"></div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="mt-10">
            <ProfilPejabat :pejabatList="formasi" inline :hideHeaderInline="false" title="Profil Pejabat" />
          </div>
          <div class="mt-10">
            <ProfilPegawai :pegawaiList="pegawai" inline :hideHeaderInline="false" title="Profil Pegawai" />
          </div>
        </section>
      </main>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>
<script setup>
import { ref } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";
import ProfilPejabat from "@/Components/Web/ProfilPejabat.vue";
import ProfilPegawai from "@/Components/Web/ProfilPegawai.vue";

const showFullText = ref(false);

function toggleText() {
  showFullText.value = !showFullText.value;
}
const props = defineProps({
  profil: {
    type: Object,
    required: true,
  },
  formasi: {
    type: Object,
    required: true,
  },
  pegawai: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
/* Custom styles for ordered list in Misi content */
:deep(ol) {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin: 1rem 0;
}

:deep(ol li) {
  margin-bottom: 1rem;
  line-height: 1.6;
  padding-left: 0.5rem;
}

:deep(ol li strong) {
  font-weight: 600;
  color: #1f2937;
}

/* Ensure proper spacing for nested content */
:deep(p) {
  margin: 0.5rem 0;
}

/* Custom scrollbar styles */
.scrollbar-thin {
  scrollbar-width: thin;
}

.scrollbar-thumb-gray-300::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 6px;
}

.scrollbar-track-gray-100::-webkit-scrollbar-track {
  background-color: #f3f4f6;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Mobile responsiveness */
@media (max-width: 1024px) {
  .flex-col {
    flex-direction: column;
  }

  .sticky {
    position: relative;
    top: auto;
  }

  .overflow-y-auto {
    max-height: 500px;
  }
}

@media (max-width: 768px) {
  .overflow-y-auto {
    max-height: 400px;
  }

  .space-y-8 {
    gap: 1.5rem;
  }

  h2,
  .text-xl {
    font-size: 1.125rem;
  }
}

/* Sticky image positioning */
.sticky {
  position: sticky;
  top: 1rem;
}

/* Smooth fade effect for content sections */
.space-y-8>div {
  transition: all 0.3s ease-in-out;
  padding: 0.5rem;
  border-radius: 4px;
}

.space-y-8>div:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #f9fafb;
}
</style>
